import type { ServerContext } from '@/hooks/server/use-server-context'

import type { GlossaryLabels } from './types'

export const glossaryLabels = (t: ServerContext['t']): GlossaryLabels => ({
  title: t('glossary.title', 'Hearing aid glossary'),
  close: t('glossary.close', 'Close glossary'),
  loading: t('glossary.loading', 'Looking that up…'),
  error: t('glossary.error', 'This definition could not be loaded. Please try again.'),
  retry: t('glossary.retry', 'Try again'),
  note: t('glossary.note', 'Terms are matched automatically. A definition may not fit every context.'),
})
